import { TranslateService } from "@ngx-translate/core";
import { Component, Input, OnInit } from "@angular/core";
import { ThisPlatform } from "src/app/_services/platform.service";

@Component({
  selector: "app-api-not-found",
  templateUrl: "./api-not-found.component.html",
  styleUrls: ["./api-not-found.component.scss"],
})
export class APINotFoundComponent implements OnInit {
  @Input()
  name: string = "";
  @Input()
  returnText: string = "ERROR.GO_TO_MAIN_PAGE";
  @Input()
  link: string = "app/home";
  @Input()
  status: number;

  header: string;
  message: string;

  constructor(private translate: TranslateService, public p: ThisPlatform) {}

  ngOnInit() {
    let headerTranslationKey, messageTranslationKey;
    switch (this.status) {
      case 400: {
        headerTranslationKey = "ERROR.HTTP_400";
        messageTranslationKey = "ERROR.CHECK_URL";
        break;
      }
      case 401: {
        headerTranslationKey = "ERROR.HTTP_401";
        messageTranslationKey = "ERROR.NO_ACCES";
        break;
      }
      case 403: {
        headerTranslationKey = "ERROR.HTTP_403";
        messageTranslationKey = "ERROR.NO_ACCES";
        break;
      }
      case 404: {
        //headerTranslationKey =
          // this.translate.instant(this.name) +
          // this.translate.instant("ERROR.ITEM_NOT_FOUND");
        messageTranslationKey = "ERROR.CHECK_URL";
        break;
      }
      case 408: {
        headerTranslationKey = "ERROR.HTTP_408";
        messageTranslationKey = "ERROR.HTTP_408_MESSAGE";
        break;
      }
      case 500: {
        headerTranslationKey = "ERROR.HTTP_500";
        messageTranslationKey = "ERROR.MESSAGE";
        break;
      }

      default: {
        headerTranslationKey = "ERROR.HEADER";
        messageTranslationKey = "ERROR.MESSAGE";
      }
    }
    this.header = this.translate.instant(headerTranslationKey);
    this.message = this.translate.instant(messageTranslationKey);
  }
}
